import React from 'react';
import { connect } from 'react-redux';
import { Segment, Divider, Checkbox } from 'semantic-ui-react';
import { useIntl } from 'react-intl';
import { states } from '@/constants/lifecycle';
import { workspaceFormHealthSources, workspaceForms } from '@/workspaces/constants';
import Fetch from '@/workspaces/hooks/fetch';
import { toggleWorkspaceRequest } from '../actions';
import { newRequest, resolveRequestWorkflow } from '../../state/state';
import { supportsRequestWorkspace } from '../../helper';

const RequestWorkspaceSegment = ({
  allowNew,
  category,
  children,
  code,
  readStatus,
  requestNewWorkspace,
  toggleNewWorkspace,
}) => {
  const intl = useIntl();
  Fetch.useWorkspaceFormHealthCheck({
    code: workspaceForms.REQUEST,
    source: workspaceFormHealthSources.DAR,
  }, readStatus);

  return (
    <>
      {allowNew && (
        <>
          <Segment textAlign="center" secondary>
            <Checkbox
              checked={requestNewWorkspace}
              label={intl.formatMessage({ id: 'request.new.workspace' })}
              toggle
              className="bold"
              onClick={() => toggleNewWorkspace(category, code)}
            />
          </Segment>
          <Divider horizontal content={intl.formatMessage({ id: 'operand.or' })} />
        </>
      )}
      {children}
    </>
  );
};

const mapStateToProps = ({
  requests: { requests },
  workflows: { workflows },
  workspaces: { forms: { health } },
}, ownProps) => {
  const { request } = resolveRequestWorkflow(requests, workflows, ownProps, newRequest(ownProps));
  const { readStatus } = health[workspaceForms.REQUEST];

  return ({
    allowNew: supportsRequestWorkspace(request) && readStatus === states.SUCCESS,
    readStatus,
    requestNewWorkspace: request.workspace_requested,
  });
};

const mapDispatchToProps = {
  toggleNewWorkspace: toggleWorkspaceRequest,
};

export default connect(mapStateToProps, mapDispatchToProps)(RequestWorkspaceSegment);
